
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/settings';

/**
 * 艺人（商户端）
 * 个人艺人 + 艺术团体统一；字典在平台端维护
 * 菜单 route 对齐：/artist、/artist/desk、/artist/profile、/artist/browse、/artist/invite、/artist/perform
 */
const artistRouter: RouteRecordRaw = {
  path: `${roterPre}/artist`,
  name: 'Artist',
  component: Layout,
  alwaysShow: true,
  // 侧栏归入「活动 → 艺人」；此处仅注册路由与面包屑
  meta: {
    title: '艺人',
    icon: 'collection',
  },
  children: [
    {
      path: 'profile',
      name: 'ArtistProfile',
      meta: {
        title: '我的艺人',
        noCache: true,
        activeMenu: `${roterPre}/artist/desk`,
      },
      component: () => import('@/views/_expand/artGroup/index.vue'),
    },
    {
      path: 'desk',
      name: 'ArtistProfileBoard',
      component: () => import('@/views/_expand/artGroup/board.vue'),
      meta: {
        title: '艺人控制台',
        noCache: true,
        activeMenu: `${roterPre}/artist/desk`,
      },
    },
    {
      path: 'profile/board',
      redirect: (to) => ({ path: `${roterPre}/artist/desk`, query: to.query }),
      hidden: true,
    },
    {
      path: 'profile/edit',
      name: 'ArtistProfileEdit',
      component: () => import('@/views/_expand/artGroup/edit.vue'),
      meta: {
        title: '编辑艺人',
        noCache: true,
        activeMenu: `${roterPre}/artist/desk`,
      },
      hidden: true,
    },
    {
      path: 'profile/member',
      name: 'ArtistProfileMember',
      component: () => import('@/views/_expand/artGroup/member.vue'),
      meta: {
        title: '团员管理',
        noCache: true,
        activeMenu: `${roterPre}/artist/desk`,
      },
      hidden: true,
    },
    {
      path: 'browse',
      name: 'CollaborationArtistInviteBrowse',
      component: () => import('@/views/_expand/collaboration/artist-invite/browse.vue'),
      meta: {
        title: '艺人库',
        noCache: true,
        activeMenu: `${roterPre}/artist`,
      },
    },
    {
      path: 'invite',
      name: 'CollaborationArtistInvite',
      meta: {
        title: '约档',
        noCache: true,
      },
      component: () => import('@/views/_expand/collaboration/artist-invite/index.vue'),
    },
    {
      path: 'invite/edit',
      name: 'CollaborationArtistInviteEdit',
      component: () => import('@/views/_expand/collaboration/artist-invite/edit.vue'),
      meta: {
        title: '编辑约档',
        noCache: true,
        activeMenu: `${roterPre}/artist/invite`,
      },
      hidden: true,
    },
    {
      path: 'perform',
      name: 'PerformLst',
      meta: {
        title: '出演',
        noCache: true,
        activeMenu: `${roterPre}/artist/desk`,
      },
      component: () => import('@/views/_expand/perform/index.vue'),
    },
    {
      path: 'group',
      redirect: { name: 'ArtistProfile' },
      hidden: true,
    },
    {
      path: 'group/edit',
      redirect: (to) => ({ name: 'ArtistProfileEdit', query: to.query }),
      hidden: true,
    },
    {
      path: 'group/member',
      redirect: (to) => ({ name: 'ArtistProfileMember', query: to.query }),
      hidden: true,
    },
  ],
};

export default artistRouter;
